import CustomButtonController from './custom-button.controller';
import { CustomButtonProps } from './custom-button.model';

const CustomButton = (props: CustomButtonProps): JSX.Element => {
  return <CustomButtonController {...props} />;
};

export default CustomButton;
